import React from 'react';

import { ChipProps as MUIChipProps } from '@mui/material';

import { StyledChip } from './index.styles';

export interface ChipProps extends MUIChipProps {
  /**
   * If `true`, the button text is all caps
   */
  allCaps?: boolean,
  cursorType?: 'pointer' | 'default',
}

const Chip = ({ disabled = false,
  cursorType = 'default',
  color = 'darkPrimary',
  variant = 'filled',
  allCaps = false,
  ...rest }: ChipProps) =>
  (
    <StyledChip
      disabled={disabled}
      color={disabled ? 'gray' : color}
      variant={disabled ? 'outlined' : variant}
      $allCaps={allCaps}
      {...rest}
      $cursorType={cursorType}
    />
  );

export default Chip;
